import { InternalAxiosRequestConfig } from 'axios';

export function injectTenantDomainInterceptor(
  config: InternalAxiosRequestConfig,
) {
  const tenantDomainFromUrl = extractTenantDomainFromUrl();
  config.headers = config.headers ?? {};
  config.headers['Tenant-Domain'] = tenantDomainFromUrl;
  return config;
}

/**
 * Extract tenant domain part of URL
 * e.g. 'https://test.lmpatientmanager.com' -> 'test'
 * */
export function extractTenantDomainFromUrl() {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  return parts.length > 2 ? parts[0] : '';
}
